import pluralize from "pluralize";
import {useFormContext} from "react-hook-form";

import {FormLabel} from "@/components/form/FormLabel.tsx";
import {Input} from "@/components/input/Input.tsx";

interface GroupChecksSelectorProps {
  toggleSubform: () => void;
  label: string;
  tooltip: string;
  name: string;
}

export const GroupChecksSelector = ({name, label, tooltip, toggleSubform}: GroupChecksSelectorProps) => {
  const {watch} = useFormContext();
  const fieldValue = watch(name);
  const amount = fieldValue?.length || 0;
  const value = amount > 0 ? `${amount} ${pluralize("Check", amount)} selected` : "";
  return (
    <>
      <FormLabel helpText={tooltip} forId={name}>
        {label}
      </FormLabel>
      <Input
        placeholder="Select Checks..."
        value={value}
        onChange={() => {}}
        type="text"
        className="form-control cursor-pointer"
        onFocus={() => toggleSubform()}
      />
    </>
  );
};
